import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0ba5ab7a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "exhibition"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "after"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "arrow"
}, null, -1));
const _hoisted_6 = {
  class: "wapper"
};
const _hoisted_7 = {
  key: 0,
  class: "dialog"
};
const _hoisted_8 = {
  class: "dialog__body"
};
const _hoisted_9 = {
  class: "dialog__body-title"
};
import { computed, ref } from 'vue';
import { store } from '@remote/store';
import { IconClose } from '@xunlei/thunder-icon-vue';
import { newToast, toast } from '@remote/utils';
import { stat } from '@remote/utils/stat';
import { openDeviceList, openPopRemoteDownloadGuide } from '@remote/utils/dialog';
import router from '@remote/router';
import { useDeviceStore } from '@remote/store/device';
import { KUAINIAO_URL } from '@shared/constants/URLs';
export default /*#__PURE__*/_defineComponent({
  __name: 'SettingItem',
  props: {
    title: {
      type: String,
      default: ''
    },
    listTitle: {
      type: String,
      default: ''
    },
    isBottom: {
      type: Boolean,
      default: false
    },
    clickId: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    nativeClick: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const showHDialog = ref(false);
    const isDownloadTaskNumSettingDisabled = computed(() => {
      var _store$state$deviceIn;
      return (_store$state$deviceIn = store.state.deviceInfoWatchData.labels) === null || _store$state$deviceIn === void 0 ? void 0 : _store$state$deviceIn.includes('withoutRunnerCountConfig');
    });
    const isDownloadSpeedSettingDisabled = computed(() => {
      var _store$state$deviceIn2;
      return (_store$state$deviceIn2 = store.state.deviceInfoWatchData.labels) === null || _store$state$deviceIn2 === void 0 ? void 0 : _store$state$deviceIn2.includes('withoutDownloadSpeedConfig');
    });
    const deviceStore = useDeviceStore();
    const handleClick = async () => {
      if (props.disabled) {
        store.commit('toast', '当前设备已离线，无法设置');
        return;
      }
      if (isDownloadSpeedSettingDisabled.value && props.clickId === 'set_downloadspeed' || isDownloadTaskNumSettingDisabled.value && 'downloadtask_num' === props.clickId) {
        toast('当前设备不支持该设置项');
        return;
      }
      if (props.clickId) {
        stat({
          action: 'mytab_page_click',
          data: {
            click_id: props.clickId
          }
        });
      }
      if (props.nativeClick) {
        emit('click');
      } else {
        // TODO: 这里处理弹出弹窗
        if (props.clickId === 'remote_device') {
          openDeviceList({
            canRemoveDevice: true,
            actionFrom: 'mytab'
          });
          return;
        }
        if (props.clickId === 'remote_download_guide') {
          stat({
            action: 'mytab_remote_download_item_click'
          });
          openPopRemoteDownloadGuide({});
          return;
        }
        if (props.clickId === 'kuainiao') {
          var _deviceStore$currentD;
          stat({
            action: 'mytab_kuainiao_click'
          });
          await deviceStore.untilDeviceReady();
          // 设备在线状态判断
          if (((_deviceStore$currentD = deviceStore.currentDeviceRef) === null || _deviceStore$currentD === void 0 ? void 0 : _deviceStore$currentD.runnerTaskRef.phase) === 'PHASE_TYPE_RUNNING') {
            // 跳转到快鸟页面
            router.push({
              name: 'pluginIframe',
              query: {
                ...router.currentRoute.value.query,
                currentIframeUrl: KUAINIAO_URL,
                currentIframeTitle: '快鸟宽带提速'
              }
            });
          } else {
            newToast({
              message: '当前设备已离线，无法设置',
              type: 'info'
            });
          }
          return;
        }
        showHDialog.value = true;
      }
    };
    const close = () => {
      showHDialog.value = false;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["info", {
          'is-bottom': __props.isBottom
        }]),
        onClick: _cache[0] || (_cache[0] = $event => handleClick())
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createTextVNode(_toDisplayString(__props.title) + " ", 1), _renderSlot(_ctx.$slots, "title")])]), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "extra"), _hoisted_5])], 2)]), (_openBlock(), _createBlock(_Teleport, {
        to: "#app"
      }, [_createElementVNode("div", _hoisted_6, [_createVNode(_Transition, {
        name: "mask"
      }, {
        default: _withCtx(() => [showHDialog.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "cover",
          onClick: close
        })) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_Transition, {
        name: "pop"
      }, {
        default: _withCtx(() => [showHDialog.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("h2", null, _toDisplayString(__props.listTitle), 1), _createVNode(_unref(IconClose), {
          title: "关闭",
          onClick: close,
          width: "20",
          height: "20"
        })]), _renderSlot(_ctx.$slots, "content", {
          close: close
        }, () => [_createTextVNode(" 这里空空如也~ ")])])])) : _createCommentVNode("", true)]),
        _: 3
      })])]))]);
    };
  }
});